import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { styled, useTheme } from '@mui/material';
import {
  Menu,
  ChevronLeft,
  ChevronRight,
  Home,
  Co2,
  GridView,
  SupportAgent,
  HomeRepairService
} from '@mui/icons-material';
import MainLayout from './MainLayout';
import { APP_NAME } from '../../actions/constants';
import MuiDrawer from '@mui/material/Drawer';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import MuiAppBar from '@mui/material/AppBar';
import {
  Button,
  Grid,
  Box,
  Toolbar,
  List,
  CssBaseline,
  Typography,
  Divider,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip
} from '@mui/material';
// import Login from '../auth/Login';
import { getUserDetails, logout } from '../../actions/auth';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Notification from './Notification';
import { useDispatch, useSelector } from 'react-redux';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import CategoryIcon from '@mui/icons-material/Category';
import PeopleIcon from '@mui/icons-material/People';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import FormatListNumberedRtlIcon from '@mui/icons-material/FormatListNumberedRtl';
import * as DarkReader from 'darkreader';
const drawerWidth = 300;

const openedMixin = theme => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = theme => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const Main = ({ logout }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  // const [openLogin, setOpenLogin] = useState(false);
  // const { cfUserData } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const { userData } = useSelector(state => state.auth);
  const [activeSidebarItem, setActiveSidebarItem] = useState('Home');
  // const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(getCfUserDetails());
  // }, [dispatch]);

  // const adminRoles = cfUserData?.admin_roles?.map(e => e.role.toLowerCase());

  const isBiocharOrConservationBurnUser = userData?.carbonFootprintUser === null && userData?.tigercatBurnsUser === null;
  const isCarbonFootprintUser = userData?.carbonFootprintUser !== null;
  const isTigercatBurnsUser = userData?.tigercatBurnsUser !== null;

  // console.log('biochar', isBiocharOrConservationBurnUser, 'cf', isCarbonFootprintUser, 'tiger', isTigercatBurnsUser);

  const navigate = useNavigate();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const { page } = useParams();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  useEffect(() => {
    // Check the saved preference and apply it
    const savedMode = localStorage.getItem('dark-mode');
    if (savedMode === 'enabled') {
      DarkReader.enable({
        brightness: 100,
        contrast: 90,
        sepia: 10
      });
      setIsDarkMode(true);
    }
  }, []);

  const [mode, setMode] = useState('light');
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleMode = () => {
    setMode((prevState) => (prevState === 'light' ? 'dark' : 'light'));

    if (isDarkMode) {
      DarkReader.disable();
      localStorage.setItem('dark-mode', 'disabled');
    } else {
      DarkReader.enable({
        brightness: 100,
        contrast: 90,
        sepia: 10
      });
      localStorage.setItem('dark-mode', 'enabled');
    }
    setIsDarkMode(!isDarkMode);

  };

  let items = [
    { name: 'Home', component: <Home /> },
    { name: 'Programs', component: <GridView /> },
    { name: 'Data Capturing', component: <KeyboardIcon /> },
    { name: 'Conversion Factors', component: <Co2 /> },
    { name: 'General Information', component: <AddHomeWorkIcon /> },
    { name: 'Resources', component: <HomeRepairService /> },
    { name: 'Support & FAQs', component: <SupportAgent /> },
    { name: 'Operations', component: <LocalFireDepartmentIcon /> },
    { name: 'CAR Reporting', component: <GridView /> },
    { name: 'Project Assets', component: <CategoryIcon /> },
    { name: 'Factors', component: <FormatListNumberedRtlIcon /> },
    { name: 'Users', component: <PeopleIcon /> }
  ];

  if (isBiocharOrConservationBurnUser) {
    items = items.filter((i) =>
      i.name == 'Home' ||
      i.name == 'Programs' ||
      i.name == 'Resources' ||
      i.name == 'Support & FAQs' ||
      i.name == 'Users'
    );
  } else if (isCarbonFootprintUser && userData?.carbonFootprintUser?.group === null) {
    items = items.filter((i) =>
      i.name == 'Home' ||
      i.name == 'Data Capturing' ||
      i.name == 'Conversion Factors' ||
      i.name == 'General Information'
    );
  } else if (isCarbonFootprintUser && userData?.carbonFootprintUser?.group !== null) {
    items = items.filter((i) =>
      i.name == 'Home' ||
      i.name == 'Data Capturing' ||
      i.name == 'General Information'
    );
  } else if (isTigercatBurnsUser) {
    items = items.filter((i) =>
      i.name == 'Home' ||
      i.name == 'Operations' ||
      i.name == 'CAR Reporting' ||
      i.name == 'Project Assets' ||
      i.name == 'Factors' ||
      i.name == 'Users'
    );
  }

  const userType = {
    isBiocharOrConservationBurnUser,
    isCarbonFootprintUser: userData?.carbonFootprintUser,
    isTigercatBurnsUser: userData?.tigercatBurnsUser
  }

  // console.log(userData, 'show me user')

  if (!userData?.isAdmin) {
    items = items.filter(i => i.name !== 'Users');
  }
  // if (!adminRoles?.includes('overview')) {
  //   items = items.filter(i => i.name !== 'Carbon Footprinting');
  // }

  return (
    <Box sx={{ display: 'flex' }}>
      <Notification />
      <CssBaseline />
      <AppBar position='fixed' open={open}>
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <Menu />
          </IconButton>
          <Grid container>
            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant='h6'>{APP_NAME}</Typography>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: 'right' }}>
              {/* <Button
                variant='outlined'
                color='tertiary'
                sx={{ mr: 2 }}
                onClick={() => navigate('/dashboard')}
              >
                Dashboard
              </Button> */}
              <IconButton id="dark-mode-toggle" onClick={toggleMode} sx={{ width: 40, height: 40, mr: 2 }}>
                {mode === 'light' ? <DarkModeIcon color={'secondary'} /> : <LightModeIcon />}
              </IconButton>
              {/* {console.log(userData)} */}
              <Tooltip title={<h5 style={{ color: 'lightgreen' }}>{userData?.email}</h5>}>
                <Button
                  variant='contained'
                  color='secondary'
                  onClick={handleLogout}
                >
                  Logout {userData?.first_name ? userData.first_name : ''}
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Drawer variant='permanent' open={open}>
        <DrawerHeader>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant='h6'>{activeSidebarItem}</Typography>
          </Box>
          <Box>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRight /> : <ChevronLeft />}
            </IconButton>
          </Box>
        </DrawerHeader>
        <Divider />
        <List>
          {items.map((item, index) => (
            <ListItemButton
              key={index}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                bgcolor:
                  item.name.toLowerCase().split(' ').join('-') === page
                    ? '#eee'
                    : '',
                // display: (!adminRoles?.includes('overview') && index === 2) ? 'none' : 'none'
              }}
              component={Link}
              onClick={() => setActiveSidebarItem(item.name)}
              to={'/' + item.name.toLowerCase().split(' ').join('-')}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                {item.component}
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          ))}
        </List>
      </Drawer>
      <MainLayout userType={userType} userData={userData} isOpen={open} />
      {/* <Modal open={openLogin} onClose={() => setOpenLogin(false)}>
        <Login openLogin={val => setOpenLogin(val)} />
      </Modal> */}
    </Box>
  );
};

Main.propTypes = {
  logout: PropTypes.func.isRequired,
};

export default connect(null, { logout })(Main);
